export default __webpack_public_path__ + "static/media/circle-close-icon.fe7128e3.svg";